import { render, staticRenderFns } from "./OrcamentoSplit.vue?vue&type=template&id=2d010d73&"
import script from "./OrcamentoSplit.vue?vue&type=script&lang=js&"
export * from "./OrcamentoSplit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports